import api from '@shared/api/apiConfig';
import { hashPassword, generateRandomUserId } from '@shared/lib/security';
import {
  deleteUserByEmailURI,
  editAccessManagementUserURI,
  getUserDetailsURI,
  getUsersByEmailURI,
  getUsersByOrgIdURI,
  updateUserProfileURI,
  userChangePasswordURI
} from '@shared/api/endpoints';
import type { AccessManagementUser } from '@shared/store/userManagementSlice';
import type { SelectOption } from '@shared/api/types';

// export async function handleCreateUser(
//   userName: string,
//   email: string,
//   userType: SelectOption,
//   organization: SelectOption,
//   demandPartners: SelectOption[]
// ) {
//   const listString = demandPartners.map((option) => option.value).join(',');
//   const requestBody = {
//     userId: generateRandomUserId(),
//     emailAddress: email,
//     userType: userType.value,
//     userAlias: userName,
//     orgId: organization.value,
//     dpList: listString,
//     pubsList: listString,
//     isActive: 1
//   };

//   return api.post(createUserURI, requestBody);
// }

export async function getUsersByOrgId(orgId: string) {
  return api.get<AccessManagementUser[]>(getUsersByOrgIdURI(orgId));
}

export async function deleteUserByEmail(email: string) {
  return api.delete( deleteUserByEmailURI(email) );
}

export async function getUsersByEmail(email: string) {
  return api.get<AccessManagementUser>( getUsersByEmailURI(email) );
}


export async function editAccessManagementUser(email: string, demandPartners: SelectOption[]) {
  const requestBody = {
    emailAddress: email,
    dpList: demandPartners.map((option) => option.value).join(',')
  };
  return api.put(editAccessManagementUserURI, requestBody);
}

export async function createAccessManagementUser(
  userName: string,
  email: string,
  userType: SelectOption,
  organization: SelectOption,
  demandPartners: SelectOption[],
  publishers: SelectOption[] = []
) {
  const dpListString = demandPartners.map((option) => option.value).join(',');
  const publisherListString = publishers.map((option) => option.value).join(',');
  const requestBody = {
    userId: generateRandomUserId(),
    emailAddress: email,
    userType: userType.value,
    userAlias: userName,
    orgId: organization.value,
    dpList: dpListString,
    pubsList: publisherListString,
    isActive: 1
  };

  return api.post('https://internal.ctech.works/user-service/access-management/createUser', requestBody);
}

export async function getUserDetails() {
  return api.get(getUserDetailsURI);
}

export async function editUserDetails(firstName: string, lastName: string, email: string, phone: string) {
  const requestBody = {
    emailAddress: email,
    firstName,
    lastName,
    contactNumber: phone
  };
  return api.put(updateUserProfileURI, requestBody);
}

export async function changePassword(email: string, oldPassword: string, newPassword: string) {
  const requestBody = {
    emailAddress: email,
    oldPass: await hashPassword(oldPassword),
    newPass: await hashPassword(newPassword)
  };

  return api.put(userChangePasswordURI, requestBody);
}
